import { Component, OnInit, Output,EventEmitter, Input } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { error } from 'console';
import { HttpService } from 'src/app/core/services/http.service';
import { SettingsService } from 'src/app/core/services/settings.service';
import { ToastrTranslateService } from 'src/app/core/services/toastr-translate.service';

@Component({
  selector: 'app-add-shipping-modal',
  templateUrl: './add-shipping-modal.component.html',
  styleUrls: ['./add-shipping-modal.component.scss']
})
export class AddShippingModalComponent implements OnInit {
  @Output() closeModalEvent = new EventEmitter<boolean>();
  @Input() mediaDetails:any
  @Input() mediaData: any;
  @Input() isFromAddMedia: boolean = false; // Receive flag
  @Input() currentShipment: any;
  @Input() assetId: any;
  shippingId:any=null;
  shippingForm: FormGroup;
  derivedSettings:any
  dateForm:FormGroup;
  public defaultDate:Date=new Date();
  AssetData:any;
  assetDropdownList :any;
  selectedAssetId: any;
  mediaListDropDown:[];

  constructor(private formBuilder:FormBuilder,private httpService:HttpService,private settingsService:SettingsService,private toastr:ToastrTranslateService) {
    this.shippingForm = this.createShippingForm();
    this.derivedSettings = this.settingsService.derivedSettigs;
   }

  ngOnInit(): void {
    this.getAllAssets();

     console.log(this.getAllAssets());
     
    this.shippingForm.get('assetId')?.valueChanges.subscribe(assetId => {
      this.selectedAssetId = assetId ? parseInt(assetId, 10) : null;
      if (this.selectedAssetId) {
        this.getMediaListByAssetId(this.selectedAssetId);
      } else {
        this.mediaListDropDown = []; 
    }});
  
    if(this.currentShipment &&this.currentShipment.id){ 
     this.shippingId = this.currentShipment.id;
     this.shippingForm.get('media').setValue(this.currentShipment.mediaId ? this.currentShipment.mediaId: this.currentShipment.mediaId);
     this.shippingForm.get('carrier').setValue(this.currentShipment.carrier);
     this.shippingForm.get('trackingnumber').setValue(this.currentShipment.trackingNumber);
     this.shippingForm.get('status').setValue(this.currentShipment.status);
     this.shippingForm.get('comment').setValue(this.currentShipment.comment);
     this.shippingForm.get('type').setValue(this.currentShipment.selectedStatus);
    if(this.currentShipment.date){
      const parsedDate = new Date(this.currentShipment.date);
      this.shippingForm.get('from').setValue(parsedDate);
     }
    }
  }


  createShippingForm(){
    return this.formBuilder.group({
      assetId: [null],
      media: [null,Validators.required],
      carrier: [null],
      trackingnumber: [null],
      status: [null],
      comment: [null],
      type: [null],
      from: [new Date(this.defaultDate.getFullYear(), this.defaultDate.getMonth(), 1)] 
    });

  }

  getJSONToSaveShipping = () => {
    try {
      let shippingForm = this.shippingForm;
      if (this.isFromAddMedia) {
        this.shippingForm.get('media').setValue(this.mediaData?.id);
    }
      if(shippingForm.get('media').value == '' || shippingForm.get('media').value == 'undefined' || shippingForm.get('media').value == null){
        this.toastr.warning('please add media.');
        return;
      }
      if(shippingForm.get('carrier').value == null || shippingForm.get('trackingnumber').value == null || shippingForm.get('trackingnumber').value == 'undefined'){
        this.toastr.warning('please add shipping details.');
        return;
      }
     
      let shippingData = {
        "id": this.shippingId || null,
        "mediaId": shippingForm.get('media').value || null,
        "carrier": shippingForm.get('carrier').value || null,
        "trackingNumber":shippingForm.get('trackingnumber').value || null,
        "comment": shippingForm.get('comment').value || null,
        "status": shippingForm.get('status').value || null,
        "date":this.shippingForm.get('from').value,
        "selectedStatus": shippingForm.get('type').value || null,
      }
  
      return shippingData;
    }
    catch (err) {
      
    }
  }

  saveShipping(){
    let body = this.getJSONToSaveShipping();
     this.httpService.callApi('saveOrUpdateShipping', { body: body }).subscribe((response) => {
        this.toastr.success("Saved");
        this.shippingForm.reset();
        this.closeModalEvent.emit(false);
        
    }, error => {
      this.toastr.warning(error.error.message);
      
    });
  }

  hideShippingModal(){
    this.closeModalEvent.emit(false);
  }

  getAllAssets = () => {
    this.httpService.callApi('getAllAssetList', {}).subscribe((response) => {
      this.AssetData = response || [];     
      // Transform the data into an array of objects
      this.assetDropdownList = this.AssetData.map(asset => ({
        id: asset.id,
        description: asset.description
      }));
      console.log('Transformed Asset Data:', this.assetDropdownList);
    },
    error => {
      this.toastr.warning(error.error.message, 'Asset');
    });
  };

   // Handle the asset selection change event
//  onAssetChanged(event: any) {
//   const selectedId = event.target.value;
//   this.selectedAssetId = selectedId ? parseInt(selectedId, 10) : null;
//   console.log('Selected Asset ID:', this.selectedAssetId); // Log the selected asset id
//   this.getMediaListByAssetId();
// }

getMediaListByAssetId(id:any){
   let pathVariable = id;
  this.httpService.callApi('getMediaListByAsset',{pathVariable:pathVariable}).subscribe((respone)=>{
     this.mediaListDropDown=respone || [];
     console.log(this.mediaListDropDown);
  },
(error)=>{
  console.log(error)
})
}

// getMediaListByAssetIdnew (Id:number){
//   let pathVariable = Id;
//   this.httpService.callApi('getMediaListByAsset',{pathVariable:pathVariable}).subscribe((respone)=>{
//      this.mediaListDropDown=respone || [];
//      console.log(this.mediaListDropDown);
//   },
// (error)=>{
//   console.log(error)
// })
// }

getAssetName(assetId: number): string {
  const asset = this.assetDropdownList.find(a => a.id === assetId);
  return asset ? asset.description : '';
}
 

// Handle media change
onMediaChanged(event: any) {
  const selectedMediaId = event.target.value;
  this.shippingForm.get('media')?.setValue(selectedMediaId);
}

  

}
